import { useLayoutEffect, useState } from "react";
import { usePersistedStore } from "~/lib/stateManagement/persistedState/persistedStore";

export const useDevice = () => {
	const [hydrated, setHydrated] = useState(false);
	const defaultMobile = false;
	const defaultDesktop = false;
	const isMobile = usePersistedStore((state: { isMobile: boolean }) => state.isMobile);
	const isDesktop = usePersistedStore((state: { isDesktop: boolean }) => state.isDesktop);

	const useBrowserLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : () => {};
	useBrowserLayoutEffect(() => {
		setHydrated(true);
	}, []);

	return {
		mobile: hydrated ? isMobile : defaultMobile,
		desktop: hydrated ? isDesktop : defaultDesktop,
	};
};

export type DeviceHook = ReturnType<typeof useDevice>;
